<template>
  <div class="mt-5">
    <CountryPickerComponent />
  </div>
  <div class="card mt-5 pt-5">
    <div class="card-body">
      <div>
        <h2 class="card-title text-center mb-4">
          {{ $t(`signup.fi.flow_selection.title`) }}
        </h2>
        <p class="text-center mb-5">
          {{ $t(`signup.fi.flow_selection.description`) }}
        </p>
      </div>

      <div class="d-flex flex-column gap-4 mx-auto" style="max-width: 500px">
        <div class="option-card">
          <RouterLink
            class="btn btn-lg btn-outline-primary w-100 mb-2"
            :to="{ name: 'FISignupFlow', params: { flow: 'transfer' } }"
          >
            {{ $t(`signup.fi.flow_selection.transfer.title`) }}
          </RouterLink>
          <p class="text-muted small text-center">
            {{ $t(`signup.fi.flow_selection.transfer.description`) }}
          </p>
        </div>

        <div class="option-card">
          <RouterLink
            class="btn btn-lg btn-outline-primary w-100 mb-2"
            :to="{ name: 'FISignupFlow', params: { flow: 'authorization' } }"
          >
            {{ $t(`signup.fi.flow_selection.authorization.title`) }}
          </RouterLink>
          <p class="text-muted small text-center">
            {{ $t(`signup.fi.flow_selection.authorization.description`) }}
          </p>
        </div>
      </div>

      <p class="text-center mt-4 small text-muted">
        {{ $t(`signup.fi.flow_selection.not_sure`) }}
        <a class="btn btn-link btn-sm p-0 fw-normal" @click="openHelpCrunch">
          {{ $t(`signup.fi.flow_selection.contact_support`) }}
        </a>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHelpCrunch } from "@/composables/useHelpCrunch";
import CountryPickerComponent from "../CountryPickerComponent.vue";

const { openHelpCrunch } = useHelpCrunch();
</script>
